import React, { useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import Select from "react-select";
import { PlaceHolder } from "../../constants/PlaceHolderConstants";
import { PhoneNumberComponent } from "../../dropdown/PhoneNumberComponent";

const style = {
  control: (base) => ({
    ...base,
    boxShadow: "none",
    border: "1px solid #B4BABF",
    backgroundColor: "#F9FBFC",
    fontSize: "14px",
    minHeight: "35px",
    height: "35px",
    borderRadius: "6px",
    color: "#000000",
    whiteSpace: "nowrap",
  }),
};

function AddNewContactModal(props) {
  const {
    contactShow,
    setContactShow,
    handleContactChange,
    contacttemp,
    departmentdata,
    designationdata,
    handleConDepChange,
    condepartment,
    handleConDesChange,
    condesignation,
    handleContactSubmit,
    setConDepartment,
    setConDesignation,
    contactError,
    AdditionalContactClose,
    setContactError,
    setContactTemp
  } = props;

  const [departmentData, setDepartmentData] = useState([]);
  const [departmentdrp, setDepartmentdrp] = useState([]);
  const [designationData, setDesignationData] = useState([]);
  const [designationdrp, setDesignationdrp] = useState([]);

  useEffect(() => {
    var designationValue = designationdrp.filter(function (item) {
      return item.value === contacttemp?.designationId;
    });

    if (designationValue) setConDesignation(designationValue[0]);

    var departmentValue = departmentdrp.filter(function (item) {
      return item.value === contacttemp?.departmentId;
    });

    if (departmentValue) setConDepartment(departmentValue[0]);
  }, [
    contacttemp,
    departmentdrp,
    designationdrp,
    setConDepartment,
    setConDesignation,
  ]);

  useEffect(() => {
    setDepartmentData(departmentdata);
  }, [departmentdata]);

  useEffect(() => {
    setDesignationData(designationdata);
  }, [designationdata]);

  useEffect(() => {
    const getDepartmentData = () => {
      if (departmentData) {
        const list = formatDepartmentdrp(departmentData);
        setDepartmentdrp(list);
      }
    };
    getDepartmentData();
  }, [departmentData]);

  const formatDepartmentdrp = (list) => {
    var te = list?.map((data, index) => ({
      label: data?.departmentName,
      value: data?.id,
    }));
    return te;
  };

  useEffect(() => {
    const getDesignationData = () => {
      if (designationData) {
        const list = formatDesignationdrp(designationData);
        setDesignationdrp(list);
      }
    };
    getDesignationData();
  }, [designationData]);

  const formatDesignationdrp = (list) => {
    var te = list?.map((data, index) => ({
      label: data?.designationName,
      value: data?.id,
    }));
    return te;
  };

  return (
    <Modal show={contactShow} centered size="xl" className="addNewContactModal">
      <Modal.Header>
        <div className="">
          <h6>New Contact</h6>
        </div>
        <div className="">
          <i className="fas fa-times" onClick={AdditionalContactClose}></i>
          {/* <i className="far fa-edit" title="Edit"></i> */}
        </div>
      </Modal.Header>
      <Modal.Body>
        <div className='row'>
          <div className='col-12'>
            {" "}
            {contactError.contact && (
              <p className="form-error">{contactError.contact}</p>
            )}
          </div>
        </div>
        <div className="row">
          <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 col-sm-12 col-xs-12 mb-2">
            <div>
              <label>
                Contact Name <span className="mandatory">*</span>
              </label>
              <input
                className="form-control"
                name="name"
                value={contacttemp.name}
                type="text"
                placeholder={PlaceHolder.CONTACT_NAME}
                onChange={handleContactChange}
              ></input>
              {contactError.name && (
                <p className="form-error">{contactError.name}</p>
              )}
            </div>
          </div>
          <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 col-sm-12 col-xs-12 mb-2">
            <div>
              <label>
                Email <span className="mandatory">*</span>
              </label>
              <input
                className="form-control"
                type="text"
                placeholder={PlaceHolder.EMAIL}
                name="email"
                value={contacttemp.email}
                onChange={handleContactChange}
              ></input>
              {contactError.email && (
                <p className="form-error">{contactError.email}</p>
              )}
            </div>
          </div>
          <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 col-sm-12 col-xs-12 mb-2">
            <div>
              <label>
                Phone Number <span className="mandatory">*</span>
              </label>
              <PhoneNumberComponent errors={contactError} setValues={setContactTemp} setErrors={setContactError} filedName="phone" values={contacttemp} />
              {contactError.phone && (
                <p className="form-error">{contactError.phone}</p>
              )}
            </div>
          </div>
          <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 col-sm-12 col-xs-12 mb-2">
            <div>
              <label>Department</label>
              <Select
                //  defaultValue={[colourOptions[2], colourOptions[3]]}
                //isMulti
                name="departmentId"
                options={departmentdrp}
                className="basic-multi-select"
                onChange={handleConDepChange}
                value={condepartment}
                styles={style}
                isSearchable={false}
                placeholder={PlaceHolder.SELECT_DEPARTMENT}
              />
              {contactError.department && (
                <p className="form-error">{contactError.department}</p>
              )}
            </div>
          </div>
          <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 col-sm-12 col-xs-12 mb-2">
            <div>
              <label>Designation</label>
              <Select
                //  defaultValue={[colourOptions[2], colourOptions[3]]}
                //isMulti
                name="designationId"
                options={designationdrp}
                className="basic-multi-select"
                onChange={handleConDesChange}
                value={condesignation}
                styles={style}
                isSearchable={false}
                placeholder={PlaceHolder.SELECT_DESIGNATION}
              />
              {contactError.designation && (
                <p className="form-error">{contactError.designation}</p>
              )}
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
            <div className="text-right mt-3">
              <button
                type="button"
                className="btn cancel-btn"
                onClick={AdditionalContactClose}
              >
                Cancel
              </button>
              <button
                type="button"
                className="btn save-btn"
                onClick={handleContactSubmit}
              >
                {" "}
                {contacttemp?.id > 0 ? "Update" : "Save"}
              </button>
            </div>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
}

export default AddNewContactModal;
